import { request } from '@umijs/max';

// 获取补贴变动日志分页列表
export async function getUserButieLogPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/shop/userButieLog/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: ['user', 'order'],
    },
  });
}

// 获取补贴变动日志详情
export async function getUserButieLogInfo(values: API.FormValues) {
  return request('/api/shop/userButieLog/info', {
    method: 'POST',
    data: {
      ...values,
      with: ['user', 'order'],
    },
  });
}
